<template>
    <tbody v-if="localCue && localCue.data" :data-cue-id="localCue.id" :data-cue-parts="rowspan">
        <!-- {{ getUserDefinedValue() }} -->
        <tr :key="rowIndex" v-for="(rowId, rowIndex) in rowspanArray" :class="{ 'even_color': isEven(cueIndex+1)}">
            <template v-if="rowIndex===0">
                <td :rowspan="rowspan" class="ql-cell-empty ql-cell-select">
                    <md-checkbox v-if="editable" :value="selected" @change="val => $emit('toggleSelect', localCue.id, val)"></md-checkbox>
                </td>
                <td :rowspan="rowspan" class="ql-cell-empty" :class="{'ql-cell-attr-delete': editable}" @click="deleteCue"><md-icon v-if="editable">delete</md-icon></td>
                <td :rowspan="rowspan" class="ql-cell-text-center ql-cell-field-pageNumber" :title="jumpTooltip" @click="switchViewToPage">{{project.pdfPageNumbers && project.pdfPageNumbers[localCue.pageNumber - 1] &&
                    project.pdfPageNumbers[localCue.pageNumber - 1].name && project.pdfPageNumbers[localCue.pageNumber - 1].name ? project.pdfPageNumbers[localCue.pageNumber - 1].name : localCue.pageNumber}}</td>
                <td :rowspan="rowspan" class="ql-cell-layer-color" :style="layerColor"></td>
                <td :rowspan="rowspan" class="ql-cell-field-layer" :class="{'ql-cell-editable': editable}">
                    <select v-if="editable" tabindex v-model="localCueLayerId" @change="updateCueLayer" v-bind="qlAttrs('__layer__', null, 'select')" >
                        <option v-for="ll in layerOptions" :value="ll.value" :key="ll.value">{{ll.text}}</option>
                    </select>
                    <div v-else>
                        <div v-for="ll in viewLayersOtions" :value="ll.value" :key="ll.value">{{ll.value === localCueLayerId ? ll.text : ""}}</div>
                    </div>
                </td>
                <td :rowspan="rowspan" class="ql-cell-field-title" :class="{'ql-cell-editable': editable}">
                    <div v-if="editable" contenteditable tabindex class="ql-cell-editable-div" v-bind="qlAttrs('title')" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit('title', $event)" @blur="stopEditFiled('title', $event)" v-text="localCue.title"></div>
                    <div v-else tabindex class="ql-cell-editable-div" v-text="localCue.title"></div>
                </td>
            </template>
            <template v-for="attr in availableColumns">
                <td v-if="isPartsData(attr) && (attr !== 'user1' && attr !== 'user2' && attr !== 'user3' && attr !== 'user4')" :class="{['sdfdsf ql-cell-attr-' + attr]: true, 'ql-cell-editable': editable && localCue.layer.attributes[attr]}" :key="attr + '_part_' + rowIndex">
                    <template v-if="localCue.data.parts">
                        <template v-if="attr==='parts_id'">
                            <div v-if="editable" contenteditable tabindex class="ql-cell-editable-div" :class="attr + '_' + rowIndex" v-bind="qlAttrs('parts_id', rowIndex, 'text', 'id')" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit('id', $event)" @blur="stopEdit('id', $event, rowIndex)" v-text="localCue.data.partsData[rowIndex]['id']"></div>
                            <template v-else>{{localCue.data.partsData[rowIndex]['id'] || ''}}</template>
                        </template>
                        <template v-else-if="attr==='parts_label'">
                            <div v-if="editable" contenteditable tabindex class="ql-cell-editable-div" :class="attr + '_' + rowIndex" v-bind="qlAttrs('parts_label', rowIndex, 'text', 'label')" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit('label', $event)" @blur="stopEdit('label', $event, rowIndex)" v-text="localCue.data.partsData[rowIndex]['label']"></div>
                            <template v-else>{{localCue.data.partsData[rowIndex]['label'] || ''}}</template>
                        </template>
                        
                        <template v-if="localCue.layer.attributes[attr] && editable">
                            <template v-if="attr==='mark'">
                                <select tabindex v-model="localCue.data.partsData[rowIndex].mark" @change="updateCue" v-bind="qlAttrs('mark', rowIndex, 'select')" >
                                    <option v-for="(mark, index) in ['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']" :value="mark" :key="index">{{mark}}</option>
                                </select>
                            </template>
                            <div v-else contenteditable tabindex class="ql-cell-editable-div" :class="attr + '_' + rowIndex" v-bind="qlAttrs(attr, rowIndex)" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(attr, $event)" @blur="stopEdit(attr, $event, rowIndex)" v-text="localCue.data.partsData[rowIndex][attr]"></div>
                        </template>
                        <template v-else>{{localCue.data.partsData[rowIndex][attr] || ''}}</template>
                    </template>
                    <template :rowspan="rowspan" class="ql-cell-field-title" :class="{'ql-cell-editable': editable}" v-else-if="(attr=='user1' || attr=='user2' || attr=='user3' || attr=='user4')">
                        <template v-if="localCue.data[attr]">
                            <!-- {{ getUserDefined[attr].label }} -->
                            <b v-if="getUserDefined[attr].label" class="black">{{ getUserDefined[attr].label }}: </b>
                            <b v-else class="gray">{{ (attr.charAt(0).toUpperCase() + attr.slice(1))  }}: </b>
                        </template>
                        <div v-if="editable" contenteditable tabindex class="ql-cell-editable-div" :class="attr + '_' + rowIndex" v-bind="qlAttrs(attr)" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(attr, $event)" @blur="stopEdit(attr, $event)" v-text="localCue.data[attr]"></div>
                        <template v-else>
                             {{ localCue.data[attr] || '' }}
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="localCue.layer.attributes[attr] && editable">
                            <template v-if="attr==='mark'">
                                <select tabindex v-model="localCue.data.mark" @change="updateCue" v-bind="qlAttrs('mark', null, 'select')" >
                                    <option v-for="(mark, index) in ['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']" :value="mark" :key="index">{{mark}}</option>
                                </select>
                            </template>
                            <div v-else contenteditable tabindex class="ql-cell-editable-div" v-bind="qlAttrs(attr)" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(attr, $event)" @blur="stopEdit(attr, $event)" v-text="localCue.data[attr]"></div>
                        </template>
                        <template v-else>{{localCue.data[attr] || ''}}</template>
                    </template>
                </td>
                <td v-else-if="rowIndex===0 && (attr !== 'user1' && attr !== 'user2' && attr !== 'user3' && attr !== 'user4')" :rowspan="rowspan" :class="{['iiiii ql-cell-attr-' + attr]: true, 'ql-cell-editable': editable && localCue.layer.attributes[attr]}" :key="attr">
                    <!-- Linked show (Josh, 9 Oct 2026): the Notes List column. Add Note + open count on every row; a
                         Cuelist work note still live on the cue is read-only here until it is archived. -->
                    <div v-if="attr==='workNote' && notesListColumn" class="ql-noteslist-cell">
                        <span class="ql-noteslist-slot">
                            <button
                                type="button"
                                class="ql-noteslist-add"
                                aria-label="Add Note in The Notes List"
                                @click.stop="openNotesListAddNote">
                                <img class="ql-noteslist-add-icon" :src="noteslistNoteIconSrc" alt="" />
                                <img class="ql-noteslist-add-icon ql-noteslist-add-icon--hover" :src="noteslistNoteIconHoverSrc" alt="" />
                                <md-tooltip md-direction="top">Add Note in The Notes List</md-tooltip>
                            </button>
                            <span v-if="notesListOpen" class="ql-noteslist-count" :title="notesListOpen + (notesListOpen === 1 ? ' open note' : ' open notes') + ' in The Notes List'">
                                <svg class="ql-noteslist-count-mark" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path fill="currentColor" d="M218.29,182.17a12,12,0,0,1-16.47,4.12L140,149.19V216a12,12,0,0,1-24,0V149.19l-61.82,37.1a12,12,0,1,1-12.35-20.58L104.68,128,41.83,90.29A12,12,0,1,1,54.18,69.71L116,106.81V40a12,12,0,0,1,24,0v66.81l61.82-37.1a12,12,0,1,1,12.35,20.58L151.32,128l62.85,37.71A12,12,0,0,1,218.29,182.17Z"/></svg>{{ notesListOpen }}
                            </span>
                        </span>
                        <span v-if="leftoverWorkNote !== null" class="ql-noteslist-leftover">
                            <span class="ql-noteslist-leftover-tag">Cuelist work note</span>
                            <span class="ql-noteslist-leftover-text">{{ leftoverWorkNote }}</span>
                            <md-button class="md-icon-button btn-archive-cue" v-if="editable" @click="archivedWorkNote(leftoverWorkNote, $event)">
                                <md-icon>move_to_inbox</md-icon>
                                <md-tooltip md-direction="top">Archive note</md-tooltip>
                            </md-button>
                            <md-tooltip md-direction="top">Read-only on a show linked to The Notes List. Archive it when you're done with it.</md-tooltip>
                        </span>
                    </div>
                    <template v-else-if="(localCue.layer.attributes[attr] || attr==='workNote') && editable">
                        <template v-if="attr==='parts'">
                            <select tabindex v-model="localCue.data.parts" @change="partsChanged" v-bind="qlAttrs('parts', null, 'select')" >
                                <option v-for="(part, index) in ['', 2,3,4,5,6,7,8]" :value="part" :key="index">{{part}}</option>
                            </select>
                        </template>
                        <template v-else-if="attr=='block'">
                            <select tabindex v-model="localCue.data.block" @change="updateCue" v-bind="qlAttrs('block', null, 'select')" >
                                <option v-for="(block, index) in ['', 'B', 'I', 'b']" :value="block" :key="index">{{block}}</option>
                            </select>
                        </template>
                        <template v-else-if="attr=='assert'">
                            <select tabindex v-model="localCue.data.assert" @change="updateCue" v-bind="qlAttrs('assert', null, 'select')" >
                                <option v-for="(assert, index) in ['', 'A', 'a']" :value="assert" :key="index">{{assert}}</option>
                            </select>
                        </template>
                        <template v-else-if="attr==='followHang'">
                            <div style="display:flex; align-items:center; gap:6px;">
                                <select tabindex v-model="localCue.data.followHangType" @change="updateCue" style="flex:0 0 auto;" v-bind="qlAttrs('followHang', null, 'select', 'followHangType')">
                                    <option v-for="(fh, index) in ['', 'F', 'H']" :value="fh" :key="index">{{fh}}</option>
                                </select>
                                <div contenteditable tabindex class="ql-cell-editable-div" style="flex:1 1 auto; min-width:0;" v-bind="qlAttrs('followHang', null, 'text', 'followHang')" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(attr, $event)" @blur="stopEdit(attr, $event)" v-text="localCue.data.followHang"></div>
                            </div>
                        </template>
                        <template v-else-if="attr=='consumable'">
                            <select tabindex v-model="localCue.data.consumable" @change="updateCue" v-bind="qlAttrs('consumable', null, 'select')">
                                <option v-for="(consumable, index) in ['N', 'Y']" :value="consumable" :key="index">{{consumable}}</option>
                            </select>
                        </template>
                        <template v-else-if="attr=='rehearsal'">
                            <select tabindex v-model="localCue.data.rehearsal" @change="updateCue" v-bind="qlAttrs('rehearsal', null, 'select')">
                                <option v-for="(rehearsal, index) in ['N', 'Y']" :value="rehearsal" :key="index">{{rehearsal}}</option>
                            </select>
                        </template>
                        <template v-else-if="attr=='actual'">
                            <select tabindex v-model="localCue.data.actual" @change="updateCue" v-bind="qlAttrs('actual', null, 'select')">
                                <option v-for="(actual, index) in ['N', 'Y']" :value="actual" :key="index">{{actual}}</option>
                            </select>
                        </template>
                        <template v-else-if="attr=='workNote'">
                            <div class="ql-cell-attr-workNote-content">
                            </div>
                            <div style="display:flex">
                                <div>
                                    <md-button tabindex class="md-icon-button md-dense btn-toggle-workNote" :class="{'workNote-marked': isActveWorkNote}" @click="toggleWorkNote">
                                        <md-icon v-show="!isActveWorkNote">check_box_outline_blank</md-icon>
                                        <md-icon v-show="isActveWorkNote">check_box</md-icon>
                                        <md-tooltip md-direction="top" v-show="!isActveWorkNote">Check or write text to add work note</md-tooltip>
                                        <md-tooltip md-direction="top" v-show="isActveWorkNote">Uncheck to delete note without archiving</md-tooltip>
                                    </md-button>
                                </div>
                                <div style="width:100%">
                                    <div class="note-item">
                                        <div contenteditable tabindex ref="ql-cell-attr-workNote ff" :id="'ql-cell-attr-workNote' + localCue.id" class="ql-cell-editable-div" v-bind="qlAttrs('workNote')" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(attr, $event)" @blur="saveWorkNote($event)" v-text="workingNote ? workingNote : ''"></div>
                                        <md-button class="md-icon-button btn-archive-cue" v-if="workingNote" @click="archivedWorkNote(workingNote, $event)">
                                            <md-icon >move_to_inbox</md-icon>
                                            <md-tooltip md-direction="top">Archive note</md-tooltip>
                                        </md-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-else contenteditable tabindex class="ql-cell-editable-div" v-bind="qlAttrs(attr)" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(attr, $event)" @blur="stopEdit(attr, $event)" v-text="localCue.data[attr]"></div>
                    </template>
                    <template v-else>
                        <div v-if="(attr==='workNote')">
                            <div v-for="(item, index) in localCue.data[attr]" :key="index">
                                <div v-if="!item.archived">
                                    {{ item.note }}
                                </div>
                            </div>
                        </div>
                        <div v-else-if="attr==='followHang'">
                            {{ (localCue.data.followHangType || '') + (localCue.data.followHang || '') }}
                        </div>
                        <div v-else>
                            {{ localCue.data[attr] }}
                        </div>
                    </template>
                </td>
            </template>
            <template v-for="layer in layerUserDefined">
                <template v-for="(ud, ui) in layer.userDefined">
                    <td v-if="rowIndex===0 && layer.id === localCueLayerId"
                        :key="ui + '_userDefined_' + layer.id"
                        :rowspan="rowspan"
                        :class="{['ql-cell-attr-' + ui]: true, 'ql-cell-editable': editable && localCue.layer.attributes[ui]}"
                        >
                        <template v-if="editable" class="ql-cell-field-title" :class="{'ql-cell-editable': editable}">
                            <div v-if="editable && localCue && localCue.layer && localCue.layer.userDefined && !localCue.layer.userDefined[ui].value" contenteditable="false" :class="ui + '_' + rowIndex" v-text="localCue.data[ui]"></div>
                            <div v-else="editable && localCue && localCue.layer && localCue.layer.userDefined && localCue.layer.userDefined[ui].value" contenteditable tabindex class="ql-cell-editable-div" :class="ui + '_' + rowIndex" v-bind="qlAttrs(ui)" v-on:keydown.esc="cancelEdit" v-on:keydown.enter="saveEdit(ui, $event)" @blur="stopEdit(ui, $event)" v-text="localCue.data[ui]"></div>
                        </template>
                        <template v-else class="ql-cell-field-title">
                           {{localCue.data[ui]}}
                        </template>
                    </td>
                    <td v-else-if="rowIndex===0">
                        <span>-</span>
                    </td>
                </template>
            </template>
        </tr>
    </tbody>
</template>

<script>
import { workNoteOf } from '@/lib/worknotes';
import { mapGetters } from 'vuex';

import Utils from '@/lib/Utils';
import { NOTESLIST_INTEGRATION_ENABLED } from '@/lib/URLs';
import notesListOpenCount from '@/lib/noteslist-note-counts';
import { liveWorkNoteText } from '@/lib/noteslist-column';
import openNotesListAddNote from '@/lib/noteslist-add-note';
import noteslistNoteIcon from '@/assets/img/noteslist-note-icon.svg';
import noteslistNoteIconHover from '@/assets/img/noteslist-note-icon-hover.svg';

const ProjectListViewCueRow = {
    name: 'ProjectListViewCueRow',
    props: [
        'cue',
        'layerUserDefined',
        'editable',
        'selected',
        'availableColumns',
        'cueIndex',
        'getUserDefinedValue',
        'getAllUserDefinedKeys',
        'splitView',
        // { linked, narrow } on a show linked to The Notes List (list-view.vue), else null
        'notesListColumn'
    ],
    data: function() {
        return {
            attributes: {...Utils.cueAttributes, parts_id: 'P', parts_label: 'Label'},
            updatingTimer: null,
            localCue: this.$props.cue,
            localCueLayerId: this.$props.cue.layer.id,
            localCueDataWorkNote: !!((this.$props.cue && this.$props.cue.data && this.$props.cue.data.workNote) || false),
            localCueArchived: !!((this.$props.cue && this.$props.cue.archived) || false),
            handler: 0,
            isSelectDisabled: true,
            userDefined: {
                user1: { label: 'User 1', value: false },
                user2: { label: 'User 2', value: false },
                user3: { label: 'User 3', value: false },
                user4: { label: 'User 4', value: false }
            }
        };
    },
    computed: {
        ...mapGetters([
            'layerByCue',
            'editableLayers',
            'userProjectByUidData',
            'viewLayers',
            'project',
            'user',
            'notesListCounts'
        ]),
        // A1 counts: a plain lookup by cue id, so a 1,700-cue list costs nothing per row.
        notesListOpen() {
            if (!this.notesListColumn) return 0;
            return notesListOpenCount(NOTESLIST_INTEGRATION_ENABLED, this.project, this.notesListCounts, this.localCue.id);
        },
        leftoverWorkNote() {
            return this.notesListColumn ? liveWorkNoteText(this.localCue.data.workNote) : null;
        },
        noteslistNoteIconSrc() {
            return noteslistNoteIcon;
        },
        noteslistNoteIconHoverSrc() {
            return noteslistNoteIconHover;
        },
        layer: function() {
            return this.layerByCue(this.$props.cue);
        },
        // The page cell is clickable in BOTH modes but only ever carried a tooltip
        // in split view, so full-screen you got no hint at all. The two modes also
        // do different things: split moves the PDF pane, full-screen closes the
        // list to show the page. Say which. Matches the Structure section header.
        jumpTooltip: function() {
            return this.splitView ? 'Jump the PDF to this page' : 'Leave the list and open this page';
        },
        rowspan: function() {
            return (this.localCue.data && this.localCue.data.parts) || 1;
        },
        rowspanArray: function() {
            return Array.from({length: this.rowspan}, (v, i) => i + 1);
        },
        viewLayersOtions: function() {
            return this.viewLayers.map(layer => ({
                value: layer.id,
                text: layer.title
            }));
        },
        layerColor: function() {
            const layerColor = {
                backgroundColor: 'black'
            };
            if (this.localCue.layer) {
                layerColor.backgroundColor = this.localCue.layer.color;
            }
            return layerColor;
        },
        layerOptions: function() {
            return this.editableLayers.map(layer => ({
                value: layer.id,
                text: layer.title
            }));
        },
        isActveWorkNote() {
            if (typeof workNoteOf(this.localCue) === 'string') {
                return workNoteOf(this.localCue) === '' ? false : workNoteOf(this.localCue);
            }
            const activeNote = workNoteOf(this.localCue).filter(note => !note.archived);
            return activeNote.length ? activeNote.length : false;
        },
        workingNote() {
            return this.getWorkNote(workNoteOf(this.localCue));
        },
        getUserDefined() {
            if (this.cue.layer && this.cue.layer.userDefined) {
                return this.cue.layer.userDefined;
            }
            return {
                user1: { label: 'User 1', value: false },
                user2: { label: 'User 2', value: false },
                user3: { label: 'User 3', value: false },
                user4: { label: 'User 4', value: false }
            };
        }
    },
    watch: {
        cue: {
            handler: function() {
                this.localCue = { ...this.cue };
                this.localCueLayerId = this.cue.layer.id;
                this.localCueDataWorkNote = !!this.cue.data.workNote;
                this.localCueArchived = this.cue.archived;
            },
            deep: true
        }
    },
    methods: {
        openNotesListAddNote() {
            return openNotesListAddNote({ project: this.project, user: this.user, cue: this.localCue, toast: this.$toast });
        },
        isEven(number) {
            return number % 2 === 0;
        },
        // --- spreadsheet nav: tag an editable cell with its coordinate + identity
        // so listViewCellNav can move between cells and copy/paste. `attr` is the
        // cue field (title | id | label | <attr> | __layer__); rowIndex is the
        // parts sub-row (null for non-parts cells); kind is 'text' | 'select'.
        qlCol(attr) {
            if (attr === '__layer__') return 0;
            if (attr === 'title') return 1;
            const i = this.availableColumns.indexOf(attr);
            if (i !== -1) return 2 + i;
            const ud = (this.getAllUserDefinedKeys && this.getAllUserDefinedKeys()) || [];
            const udi = ud.indexOf(attr);
            if (udi !== -1) return 2 + this.availableColumns.length + udi;
            return 2 + this.availableColumns.length + ud.length;
        },
        qlAttrs(colAttr, rowIndex, kind, storeAttr) {
            return {
                'data-ql-cue': this.localCue.id,
                'data-ql-attr': storeAttr || colAttr,
                'data-ql-kind': kind || 'text',
                'data-ql-part': rowIndex == null ? null : rowIndex,
                'data-ql-r': (this.cueIndex * 100) + (rowIndex || 0),
                'data-ql-c': this.qlCol(colAttr)
            };
        },
        switchViewToPage: function() {
            this.$emit('switchViewToPage', this.localCue.pageNumber);
        },
        makeEditable(e) {
            e.target.contentEditable = 'true';
            e.target.focus();
        },
        cancelEdit(e) {
            document.execCommand('undo');
            e.target.blur();
        },
        saveEdit(attr, e) {
            e.stopPropagation();
            e.preventDefault();
            // Read the cell coordinate BEFORE blur — blur -> save -> store round-trip
            // can re-render (and detach) this node, so we move focus by coordinate,
            // not by the (possibly stale) element.
            const el = e.target;
            const r = el.getAttribute('data-ql-r');
            const c = el.getAttribute('data-ql-c');
            el.blur();
            if (r !== null && c !== null) {
                this.$emit('cellNavigate', { r: parseInt(r, 10), c: parseInt(c, 10), dir: 'down' });
            }
            return false;
        },
        stopEditFiled(field, e) {
            e.preventDefault();
            // No-op guard: navigation blurs cells constantly; only write on a real
            // change so arrowing through the list doesn't spam Firestore.
            if (e.target.innerText === (this.localCue[field] == null ? '' : this.localCue[field])) {
                return;
            }
            this.$nextTick(() => {
                const updatingCue = {...this.localCue, layer: this.localCue.layer.id};
                updatingCue[field] = e.target.innerText;
                this.$store.dispatch('updateCue', updatingCue);
            });
        },
        saveWorkNote(e) {
            e.preventDefault();
            const updatingCue = { ...this.localCue, layer: this.localCue.layer.id };
            if (typeof workNoteOf(this.localCue) === 'string') {
                if (e.target.innerText === '') {
                    return;
                }   
                updatingCue.data.workNote = [{note: e.target.innerText, archived: false, editedAt: Date.now()}];
            } else {
                if (e.target.innerText === '') {
                    return;
                }
                const newWorkNote = {note: e.target.innerText, archived: false, editedAt: Date.now()};
                const originWorkNotes = workNoteOf(this.localCue);
                
                const isArchived = (element) => {
                    return element.archived === false;
                };
                const activeIndex = originWorkNotes.findIndex(isArchived);
                if (activeIndex > -1) originWorkNotes.splice(activeIndex, 1);
                originWorkNotes.push(newWorkNote);
                updatingCue.data.workNote = originWorkNotes;
            }
            this.$store.dispatch('updateCue', updatingCue);
        },
        stopEdit(attr, e, partsIndex) {
            e.preventDefault();
            this.$nextTick(() => {
                const updatingCue = { ...this.localCue, layer: this.localCue.layer.id };
                if (partsIndex === undefined) {
                    if (e.target.innerText === updatingCue.data[attr]) {
                        return;
                    }
                    updatingCue.data[attr] = e.target.innerText;
                } else {
                    if (e.target.innerText === updatingCue.data.partsData[partsIndex][attr]) {
                        return;
                    }
                    updatingCue.data.partsData[partsIndex][attr] = e.target.innerText;
                }
                this.$store.dispatch('updateCue', updatingCue);
            });
        },
        partsChanged() {
            // Defer to the next tick so a value just typed into a cell — committed by stopEdit's
            // own $nextTick on blur — is already on localCue before we seed part 1 from it.
            this.$nextTick(() => {
                // Seed part 1 from the cue's current values the first time parts are added —
                // including when partsData is still the empty array from cue creation — so a time
                // entered before adding parts becomes part 1's time and the rest start blank.
                if (!this.localCue.data.partsData || !this.localCue.data.partsData.length) {
                    this.localCue.data.partsData = [{
                        id: 1,
                        label: '',
                        time: this.localCue.data.time,
                        focus: this.localCue.data.focus,
                        color: this.localCue.data.color,
                        beam: this.localCue.data.beam,
                        mark: this.localCue.data.mark
                    }];
                }
                if (this.localCue.data.parts) {
                    const cnt = (this.localCue.data.partsData && this.localCue.data.partsData.length) || 0;
                    if (cnt > this.localCue.data.parts) {
                        this.localCue.data.partsData.splice(this.localCue.data.parts);
                    } else if (cnt < this.localCue.data.parts) {
                        this.localCue.data.partsData = this.localCue.data.partsData.concat(new Array(this.localCue.data.parts - cnt).fill({
                            label: '',
                            time: '',
                            focus: '',
                            color: '',
                            beam: '',
                            mark: ''
                        }).map((partData, index) => ({...partData, id: index + cnt + 1})));
                    }
                } else {
                    if (this.localCue.data.partsData.length) {
                        this.localCue.data.time = this.localCue.data.partsData['0'].time;
                        this.localCue.data.focus = this.localCue.data.partsData['0'].focus;
                        this.localCue.data.color = this.localCue.data.partsData['0'].color;
                        this.localCue.data.beam = this.localCue.data.partsData['0'].beam;
                        this.localCue.data.mark = this.localCue.data.partsData['0'].mark;
                    }
                    this.localCue.data.partsData = null;
                }
                this.updateCue();
            });
        },
        updateCue() {
            this.$nextTick(() => {
                const updatingCue = {...this.localCue, layer: this.localCue.layer.id};
                return this.$store.dispatch('updateCue', updatingCue);
            });
        },
        updateCueLayer() {
            this.$nextTick(() => {
                const updatingCue = {...this.localCue, layer: this.localCueLayerId};
                return this.$store.dispatch('updateCue', updatingCue);
            });
        },
        deleteCue() {
            if (this.editable) this.$store.dispatch('deleteCue', this.localCue);
        },
        isPartsData(attr) {
            return ['parts_id', 'parts_label', 'time', 'user1', 'user2', 'user3', 'user4', 'focus', 'color', 'beam', 'mark'].includes(attr);
        },
        toggleWorkNote() {
            if (!this.editable) return;
            
            if (typeof workNoteOf(this.localCue) === 'string') {
                this.localCue.data.workNote = workNoteOf(this.localCue) ? '' : [{note: ' ', archived: false, editedAt: Date.now()}];
            } else if (this.isActveWorkNote) {
                this.localCue.data.workNote = '';
            } else {
                const archivedNote = workNoteOf(this.localCue).filter(note => note.archived);
                let newActiveNote = '';
                let originWorkNotes = workNoteOf(this.localCue);
                if (archivedNote.length > 0) {
                    newActiveNote = {note: ' ', archived: false, editedAt: Date.now()};
                    originWorkNotes.push(newActiveNote);
                } else {
                    originWorkNotes = '';
                }
                this.localCue.data.workNote = originWorkNotes;
            }
            this.updateCue();
        },
        toggleArchived(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable) return;
            this.localCue.archived = !this.localCue.archived;
            const updatingCue = {...this.localCue, layer: this.localCue.layer.id};
            this.$store.dispatch('updateCue', updatingCue);
        },
        archivedWorkNote(note, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable) return;

            let newWorkNotes = [];

            if (typeof workNoteOf(this.localCue) === 'string') {
                newWorkNotes = [{
                    note: workNoteOf(this.localCue),
                    archived: true,
                    editedAt: Date.now()
                }];
            } else {
                const tempWorkNote = workNoteOf(this.localCue);
                newWorkNotes = tempWorkNote.map((item) => {
                    if (!item.archived) {
                        item.archived = true;
                        item.editedAt = Date.now();
                    }
                    
                    return item;
                });
            }

            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: this.localCue.id,
                data: {
                    [key]: newWorkNotes
                }
            });
        },
        unArchivedWorkNote(note, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable) return;

            const tempWorkNote = workNoteOf(this.localCue);
            const isArchived = (element) => {
                return element.archived === false;
            };
            const activeIndex = tempWorkNote.findIndex(isArchived);
            if (activeIndex > -1) tempWorkNote.splice(activeIndex, 1);

            const newWorkNotes = tempWorkNote.map((item) => {
                if (item.editedAt === note.editedAt) {
                    item.archived = false;
                }
                
                return item;
            });
            
            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: this.localCue.id,
                data: {
                    [key]: newWorkNotes
                }
            });
        },
        getWorkNote(note) {
            if (typeof note === 'string') {
                return note === '' ? false : note;
            }
            const activeNote = note.filter(n => !n.archived);
            return activeNote.length ? activeNote[0].note : false;
        }
    },
    created: function() {
        if (!this.localCue) return;
        if (!this.localCue.data) {
            this.localCue.data = {...Object.keys(this.attributes).reduce((attrs, attr) => ({...attrs, [attr]: ''}), {}), label: this.localCue.description, partsData: []};
            this.$nextTick(() => {
                this.updateCue();
            });
        }
    }
};

export default ProjectListViewCueRow;
</script>

<style lang="scss">

.btn-archive-cue {
    width: 20px !important;
    height: 20px !important;
    min-width: 20px !important;
    min-height: 20px !important;
    padding: 0px;
    margin: 0 auto;

    .md-icon {
        width: 16px;
        min-width: 16px;
        height: 18px;
        min-height: 17px;
        font-size: 19px;
        position: relative;
        bottom: 9px;
        margin: 0 auto;
    }
}
.note-item {
    display: flex;
    justify-content: space-between;
}
// The Notes List column on a linked show (Josh, 9 Oct 2026, mock v2). Button first so the buttons line up down the
// column; purple count beside it (the settled Notes List asterisk colours); a leftover Cuelist work note greyed after.
.ql-noteslist-cell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 22px;
    min-width: 0;
}
.ql-noteslist-slot {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex: 0 0 auto;
    min-width: 48px;
}
.ql-noteslist-add {
    position: relative;
    width: 21px;
    height: 19px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    line-height: 0;
    border-radius: 3px;
    flex: 0 0 auto;
    .ql-noteslist-add-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 21px;
        height: 19px;
        object-fit: contain;
        transition: opacity 0.12s;
    }
    .ql-noteslist-add-icon--hover {
        opacity: 0;
    }
    &:hover,
    &:focus-visible {
        .ql-noteslist-add-icon {
            opacity: 0;
        }
        .ql-noteslist-add-icon--hover {
            opacity: 1;
        }
    }
    &:focus {
        outline: none;
    }
    &:focus-visible {
        box-shadow: 0 0 0 2px rgba(113, 83, 162, 0.45);
    }
}
.ql-noteslist-count {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-size: 11px;
    font-weight: 500;
    color: #7153a2;
    font-variant-numeric: tabular-nums;
    .ql-noteslist-count-mark {
        width: 9px;
        height: 9px;
    }
}
.ql-noteslist-leftover {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    padding-left: 8px;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.45);
    font-style: italic;
    .ql-noteslist-leftover-tag {
        flex: 0 0 auto;
        font-style: normal;
        font-size: 9.5px;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        padding: 0 4px;
        border-radius: 2px;
        background: rgba(0, 0, 0, 0.06);
    }
    .ql-noteslist-leftover-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }
    .btn-archive-cue {
        flex: 0 0 auto;
        margin: 0;
    }
}
.ql-project-list-view .ql-project-list-view-table tbody .even_color td .ql-noteslist-leftover {
    color: rgba(0, 0, 0, 0.45);
}
.md-theme-show-mode {
    .ql-noteslist-add {
        .ql-noteslist-add-icon {
            opacity: 0.72;
        }
        .ql-noteslist-add-icon--hover {
            opacity: 0;
        }
        &:hover,
        &:focus-visible {
            .ql-noteslist-add-icon {
                opacity: 0;
            }
            .ql-noteslist-add-icon--hover {
                opacity: 0.85;
            }
        }
    }
    .ql-noteslist-count {
        color: #c7bce2;
    }
    .ql-noteslist-leftover {
        color: rgba(255, 255, 255, 0.5);
        border-left-color: rgba(255, 255, 255, 0.18);
        .ql-noteslist-leftover-tag {
            background: rgba(255, 255, 255, 0.12);
        }
    }
    .ql-project-list-view .ql-project-list-view-table tbody .even_color td .ql-noteslist-leftover {
        color: rgba(255, 255, 255, 0.5);
    }
}
.ql-project-list-view .ql-project-list-view-table .even_color{
    background-color: #ECECEC;
}
.ql-project-list-view .ql-project-list-view-table tbody .even_color td{
    color: #000;
}
.md-theme-show-mode .ql-project-list-view .even_color .ql-cell-editable select{
    color: #000;
}
.black{
    color: #000;
}
.gray{
    color: #7e7676;
}

</style>


// WEBPACK FOOTER //
// cell-row.vue?7eb3c3c2